import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import Button from 'screens/components/basic/Button';
import DashDialog from 'screens/components/basic/DialogHeaderDashboard';

const emptyStyle = {
    width: '100%',
    height: '300px'
}

class InventoryLevel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            weekActive: false,
            monthActive: true,
            yearActive: false
        }
        this.clickInventoryWeek = this.clickInventoryWeek.bind(this);
        this.clickInventoryMonth = this.clickInventoryMonth.bind(this);
        this.clickInventoryYear = this.clickInventoryYear.bind(this);
    }

    clickInventoryWeek() {
        this.props.inventoryFilter('week');
        this.setState({
            weekActive: true,
            monthActive: false,
            yearActive: false
        })
    }

    clickInventoryMonth() {
        this.props.inventoryFilter('month');
        this.setState({
            weekActive: false,
            monthActive: true,
            yearActive: false
        });
    }

    clickInventoryYear() {
        this.props.inventoryFilter('year');
        this.setState({
            weekActive: false,
            monthActive: false,
            yearActive: true
        });
    }

    render() {
        return (
            <div id="chart6" className="sm-item col-4-p-0">
                <DashDialog text="Sales" link="/report/product-sales" classicClass="bg-ClassicLightBlue" />
                {
                    <div className="sales_height  position-relative">
                        <div>
                            {
                                this.props.loading ?
                                    <ClipLoader
                                        size={50}
                                        color={'#123abc'}
                                        loading={true}
                                    />
                                    :
                                    (this.props.inventory || []).length > 0
                                        ?
                                        <ResponsiveContainer width="100%" height={300}>
                                            <BarChart data={this.props.inventory}
                                                margin={{ top: 30, right: 30, left: 20, bottom: 5 }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="changedDate" />
                                                <YAxis />
                                                <Tooltip />
                                                <Legend />
                                                <Bar dataKey="quantity" fill="#82ca9d" />
                                            </BarChart>
                                        </ResponsiveContainer>
                                        :
                                        <div style={{ height: 300 }}>
                                            <div style={emptyStyle} ></div>
                                            <h2 className="product_inventory_lvl_msg">NO INVENTORY TO DISPLAY</h2>
                                        </div>
                            }

                        </div>
                        <div>
                            <Button name="buttonSave"
                                type="dashboardButton"
                                className={this.state.weekActive ? "productView-btns btn-selected btnNewBrandPOS mx-1 mt-2 mt-2" : "productView-btns btnNewBrandGray mx-1 mt-2"}
                                label="Last Week"
                                onTouchTap={this.clickInventoryWeek}
                            />
                            <Button name="buttonSave"
                                type="dashboardButton"
                                className={this.state.monthActive ? "productView-btns btn-selected btnNewBrandPOS mx-1 mt-2" : "productView-btns btnNewBrandGray mx-1 mt-2"}
                                label="Last Month"
                                onTouchTap={this.clickInventoryMonth}
                            />
                            <Button name="buttonCancel"
                                type="dashboardButton"
                                className={this.state.yearActive ? "productView-btns btn-selected btn-space btnNewBrandPOS mx-1 mt-2" : "productView-btns btn-space btnNewBrandGray mx-1 mt-2"}
                                label="Last Year"
                                onTouchTap={this.clickInventoryYear}
                            />
                        </div>
                    </div>
                }
            </div>
        )
    }
}

function mapStatetoProps(state) {
    return {
        branchId: state.common.branchId,
        loading: state.common.dbInventorySnapshot > 0
    }
}

export default connect(mapStatetoProps)(InventoryLevel);
